// @ts-strict-ignore
import { XMLParser } from 'fast-xml-parser';
import { crush } from '@tedconf/js-crushinator-helpers';
import { Article } from 'pages/topics/[slug]';
import truncateString from 'lib/truncate-string';

const RSS_URL = 'https://ideas.ted.com/feed/';
export const MAX_ARTICLES_SHOWN = 3;

type RSSArticles = {
  articles: Array<Article>;
  articlesTotalCount: number;
  error: Error | null;
};

export default async function getArticlesFromRSS(
  articlesTag: string
): Promise<RSSArticles> {
  const rssUrl = `${RSS_URL}?tag=${articlesTag}`;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let rssItems: any[] = [];
  let error: Error | null = null;

  try {
    const articlesResponse = await fetch(rssUrl);

    if (articlesResponse.status < 200 || articlesResponse.status >= 400) {
      throw new Error(
        `Failed to fetch RSS feed with status ${articlesResponse.status}`
      );
    }

    const rawArticles = await articlesResponse.text();

    const parser = new XMLParser({ ignoreAttributes: false });
    let data;

    try {
      data = parser.parse(rawArticles, true);
    } catch (err) {
      throw new Error(JSON.stringify(err, null, 2));
    }

    rssItems = data?.rss?.channel?.item || [];
  } catch (e) {
    // Error is returned and logged in the template
    error = e;
  }

  // When there is only one article, it is returned as an object instead of an array with one item
  if (!Array.isArray(rssItems)) {
    rssItems = rssItems ? [rssItems] : [];
  }

  const articles = rssItems.slice(0, MAX_ARTICLES_SHOWN).map(item => {
    const TRUNCATE_LENGTH = 180;
    const description =
      item.description > TRUNCATE_LENGTH
        ? truncateString(item.description, TRUNCATE_LENGTH)
        : item.description;

    const thumbnail = item['media:thumbnail']?.['@_url']
      ? crush(item['media:thumbnail']['@_url'], { width: 600 })
      : null;

    return {
      datePosted: item.pubDate,
      description,
      link: item.link,
      thumbnail: thumbnail || null,
      title: item.title
    };
  });

  return {
    articles,
    articlesTotalCount: rssItems.length,
    error
  };
}
